import { useCallback } from "react";
import useWeb3 from "../useWeb3";
import environment from "../../utils/Environment";
import { getGemsTokenContract } from "../../utils/contractHelpers";
import Web3 from "web3";

export const GetGemsBalance = () => {
  // const web3 = new Web3(
  //   // "https://cold-responsive-friday.quiknode.pro/15bbbcf85ec27b075486f39524c5741f49222932/"
  //   environment.PremiumNetRPC
  // );
  const web3 = useWeb3();
  // const tokenAddress = environment.gems;
  // const contract = getGemsTokenContract(tokenAddress, web3);
  const GetGemsBal = useCallback(
    async (account, tokenAddress, decimals) => {
      const contract = getGemsTokenContract(tokenAddress, web3);
      const approved = await contract.methods
        .balanceOf(account?.toString())
        .call();
      const bal = parseInt(approved.toString()) / 10 ** decimals;
      return bal;
    },
    []
  );

  return { GetGemsBal: GetGemsBal };
};

export default GetGemsBalance;
